import BlockSettings from '@/components/blocks/BlockSettings';
import BlockEditAdmin from '@/components/blocks/Admin/Admins/BlockEditAdmin';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';

export default [
	{
		path: 'settings',
		name: 'SettingsAdmin',
		component: BlockSettings,
		meta: {
			title: `Settings - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'my-account/edit/:id',
		name: 'MyAccountAdmin',
		component: BlockEditAdmin,
		props: {
			edit: true,
			myAccount: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `My Account Admin - ${process.env.VUE_APP_NAME}`
		}
	}
];
